import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

interface PublicRouteProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps>;
}

export const PublicRoute = ({ children, component: Component, ...rest }: PublicRouteProps) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};
